import { getSocketURL } from '../config'
var socket = require('socket.io-client')(getSocketURL(), {
  origins: "http://localhost:3000",
  credentials: false,
});

var socketID:string = '';
socket.on('connect', function(){
  if (socket.io.engine.id) {
    socketID = socket.io.engine.id;
    console.log('Socket Connection succeeded: ' + socketID);
  }
});

function subscribeToDownloadPDF(callback: Function) {
  socket.on('pdf-created', (cmykFileName: string, id: any) => callback(null, cmykFileName, id));
}

function pdfDownloadedSuccess(fileName: string) {
  socket.emit('pdf-downloaded-success', fileName);
}

function subscribeToDownloadCostReport(callback: Function) {
  socket.on('cost-report-created', (fileName: string, id: any) => callback(null, fileName, id));
}

function costReportDownloadedSuccess(fileName: string) {
  socket.emit('cost-report-downloaded-success', fileName);
}

function subscribeToDownloadOrderAnalysisReport(callback: Function)  {
  socket.on('orders-report-created', (fileName: string, id: any) => callback(null, fileName, id));
}

function subscribeToDownloadProductAnalysisReport(callback: Function)  {
  socket.on('product-analysis-report-created', (fileName: string, id: any) => callback(null, fileName, id));
}

function orderAnalysisReportDownloadedSuccess(fileName: string) {
  socket.emit('order-analysis-downloaded-success');
}

function productAnalysisReportDownloadedSuccess(fileName: string) {
  socket.emit('product-analysis-downloaded-success');
}

function subscribeToDownloadTechSheetZip(callback: Function) {
  socket.on('tech-sheet-zip-created', (fileName: string, id: any) => callback(null, fileName, id));
}

function techSheetZipDownloadedSuccess(fileName: string) {
  socket.emit('tech-sheet-zip--downloaded-success', fileName);
}
export {
  subscribeToDownloadPDF,
  pdfDownloadedSuccess,
  subscribeToDownloadCostReport,
  costReportDownloadedSuccess,
  subscribeToDownloadTechSheetZip,
  techSheetZipDownloadedSuccess,
  subscribeToDownloadOrderAnalysisReport,
  subscribeToDownloadProductAnalysisReport,
  orderAnalysisReportDownloadedSuccess,
  productAnalysisReportDownloadedSuccess,
  socketID
};



// WEBPACK FOOTER //
// ./src/services/SocketService.ts